<template>
  <nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button class="btn btn-fill btn-icon" @click="minimizeSidebar">
          <i :class="$sidebar.isMinimized ? 'fas fa-ellipsis-v' : 'fas fa-ellipsis-h'"></i>
        </button>
      </div>
      <div class="navbar-header">
        <button type="button" class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar bar1"></span>
          <span class="icon-bar bar2"></span>
          <span class="icon-bar bar3"></span>
        </button>
        <a class="navbar-brand">{{this.$route.name}}</a>
      </div>
      <div class="collapse navbar-collapse ">
        <ul class="nav navbar-nav navbar-right ">
          <drop-down ref="notificationDropdown" tag="li" title="" icon="fas fa-bell">
            <li><a href="#">{{ notificationData }}</a></li>
          </drop-down>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  export default {
    data () {
      return {
        activeNotifications: false,
        notificationData: ''
      }
    },
    methods: {
      watchSockets() {
        window.Echo.channel(`customer.${SITEKEY}.${this.user.id}`).listen(".ticket-update", (e) => {
          if(e.ticket_message == 'replied') {
            var audio = new Audio('/static/notification.mp3');
            audio.play();
              this.$notify(
              {
                component: {
                  template: '<span>Ticket replied. Please visit the tickets to see the update!</span>'
                },
                icon: 'fas fa-lightbulb',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'success',
                timeout: 18000
              });
          }
          });
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar () {
        this.$sidebar.toggleMinimize()
      }
    },
    mounted: function () {
      this.user = Webservice.getUser().then((response) => {
        if (response.data) {
          this.user = response.data;
          this.watchSockets();
        }
      });
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue